
/**
 * 从list中找出指定field的对象，需注意field应为key字段，保证唯一
 * @param {Array} list
 * @param {string} fieldName
 * @param {*} fieldValue
 * @returns {Object}
 */
const findObjByField = (list, fieldName, fieldValue) => {
  let obj = {}
  obj = list.find((item) => {
    return item[fieldName] === fieldValue
  })
  return obj
}

/**
 * 获取某一个对象的所有property的key值和value值
 * @param {Object} obj
 * @returns {Array}
 */
const getPropertyFromObj = (obj) => {
  const keyList = []
  const valueList = []
  for (var key in obj) {
    keyList.push(key)
    valueList.push(obj[key])
  }
  return [keyList, valueList]
}

/**
 * 从list中遍历取出每个对象所有property的key值和value值
 * @param {Array} list
 * @returns {Array}
 */
const getPropertyFromObjList = (list) => {
  const keyList = []
  const valueList = []
  for (var i in list) {
    for (var j in list[i]) {
      keyList.push(j)
      valueList.push(list[i][j])
    }
  }
  return [keyList, valueList]
}

/**
 * 数组元素合计
 * @param {Array} arr 
 * @returns {Number}
 */
function sum(arr) {
  var len = arr.length;
  if (len == 0) {
    return 0;
  } else if (len == 1) {
    return arr[0];
  } else {
    return arr[0] + sum(arr.slice(1));
  }
}

var decimalPointObj = { "i": "1", "ZC": "1", "j": "1", "jm": "1", "au": "2", "sc": "1" }
/**
 * 小数点位处理
 * @param {Number} 数字值
 * @param {String} 字符串值
 * @returns {String}
 */
function formatDecimalPoint(value, code) {
  code = code.replace(/[0-9]+/g, "") // 去除code中的数字
  if (decimalPointObj.hasOwnProperty(code)) { // code区分大小写
    value = value.toFixed(decimalPointObj[code])
  } else {
    value = value.toFixed(0)
  }
  return value
}

/**
 * 大数字转换，将大额数字转换为万、千万、亿等
 * @param {Number} value
 * @returns {String}
 */
function bigNumberTransform(value) {
  const newValue = ['', '', '']
  let fr = 1000
  let num = 3
  let text1 = ''
  let fm = 1
  while (value / fr >= 1) {
    fr *= 10
    num += 1
    // console.log('数字', value / fr, 'num:', num)
  }
  if (num <= 4) { // 千
    newValue[0] = parseInt(value / 1000) + ''
    newValue[1] = '千'
  } else if (num <= 8) { // 万
    text1 = parseInt(num - 4) / 3 > 1 ? '千万' : '万'
    // tslint:disable-next-line:no-shadowed-variable
    fm = text1 === '万' ? 10000 : 10000000
    if (value % fm === 0) {
      newValue[0] = parseInt(value / fm) + ''
    } else {
      newValue[0] = parseFloat(value / fm).toFixed(1) + ''
    }
    newValue[1] = text1
  } else if (num <= 16) { // 亿
    text1 = (num - 8) / 3 > 1 ? '千亿' : '亿'
    text1 = (num - 8) / 4 > 1 ? '万亿' : text1
    text1 = (num - 8) / 7 > 1 ? '千万亿' : text1
    // tslint:disable-next-line:no-shadowed-variable
    fm = 1
    if (text1 === '亿') {
      fm = 100000000
    } else if (text1 === '千亿') {
      fm = 100000000000
    } else if (text1 === '万亿') {
      fm = 1000000000000
    } else if (text1 === '千万亿') {
      fm = 1000000000000000
    }
    if (value % fm === 0) {
      newValue[0] = parseInt(value / fm) + ''
    } else {
      newValue[0] = parseFloat(value / fm).toFixed(1) + ''
    }
    newValue[1] = text1
  }
  if (value < 1000) {
    newValue[0] = value + ''
    newValue[1] = ''
  }
  return newValue.join('')
}

/**
 * 判断是否是开盘时间
 */
function isMarketTime() {
  var date = new Date()
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var week = date.getDay();
  var weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
  var hours = date.getHours().toString(); // 转string
  var minutes = date.getMinutes().toString(); // 转string
  var seconds = date.getSeconds().toString(); // 转string

  if (minutes < 10) {
    minutes = "0" + minutes; // minutes补0
  }
  if (seconds < 10) {
    seconds = "0" + seconds; // seconds补0
  }

  // 周六凌晨的夜盘后以及周日全天为非开盘时段
  if (week == 0 || week == 6 && hours + minutes >= 230) {
    console.log('当前时间未开盘')
    return false
  }
  // 周一无凌晨的夜盘
  if (week == 1 && hours + minutes < 900) {
    console.log('当前时间未开盘')
    return false
  }

  // console.log(year + "-" + month + "-" + day + " (" + weeks[week] + ") " + hours + ":" + minutes + ":" + seconds)
  // console.log(minutes)
  // console.log(hours)
  // console.log(hours + minutes >= 900)
  // console.log(parseInt(hours + minutes))

  if (!(hours + minutes >= 2100 && hours + minutes < 2400) &&
    !(hours + minutes >= 0 && hours + minutes < 230) &&
    !(hours + minutes >= 900 && hours + minutes < 1015) &&
    !(hours + minutes >= 1030 && hours + minutes < 1130) &&
    !(hours + minutes >= 1330 && hours + minutes < 1500)) {
    console.log('当前时间未开盘')
    return false
  }
  return true
}

/**
  * 数组元素交换位置
  * @param {array} arr 数组
  * @param {number} index1 添加项目的位置
  * @param {number} index2 删除项目的位置
  * index1和index2分别是两个数组的索引值，即是两个要交换元素位置的索引值，如1，5就是数组中下标为1和5的两个元素交换位置
  */
function swapArray(arr, index1, index2) {
  arr[index1] = arr.splice(index2, 1, arr[index1])[0]
  return arr
}

// 上移
function zIndexUp(arr, index, length) {
  if (index != 0) {
    return swapArray(arr, index, index - 1)
  } else {
    // alert('已到顶');
    return arr
  }
}

// 下移
function zIndexDown(arr, index, length) {
  if (index + 1 != length) {
    return swapArray(arr, index, index + 1)
  } else {
    // alert('已到底');
    return arr
  }
}

// 置顶
function zIndexTop(arr, index, length) {
  if (index != 0) {
    //首先判断当前元素需要上移几个位置
    var moveNum = index - 0
    //循环出需要一个一个上移的次数
    for (var i = 0; i < moveNum; i++) {
      swapArray(arr, index, index - 1)
      index--;
    }
  } else {
    // alert('已置顶');
  }
  return arr
}

// 置底
function zIndexBottom(arr, index, length) {
  if (index + 1 != length) {
    //首先判断当前元素需要下移几个位置
    var moveNum = length - 1 - index
    //循环出需要一个一个上移的次数
    for (var i = 0; i < moveNum; i++) {
      swapArray(arr, index, index + 1)
      index++;
    }
  } else {
    // alert('已置底')
  }
  return arr
}

const crypto = require('crypto-js');
const sortObject = require('sort-object-keys');
const base64 = require('js-base64');

const AUTHORIZATION_SIFFOX = "6e8566e348447383e16fdd1b233dbb49";
const AUTHORIZATION_PREFIX = 'web:';

// 请求参数签名
const getAuthorization = data => {
  // Construct the string to be hashed
  let l = "";
  const data_sort = sortObject(data);
  l += Object.entries(data_sort).map(([key, value]) => `${key}=${value}`).join('&');
  l += AUTHORIZATION_SIFFOX;

  // Compute the MD5 hash of the string
  const l_md5 = crypto.MD5(l).toString();

  // Construct the authorization string
  const authorization_source = AUTHORIZATION_PREFIX + l_md5;
  const authorization = base64.encode(authorization_source);

  return authorization;
}

export { findObjByField, getPropertyFromObj, getPropertyFromObjList, sum, formatDecimalPoint, bigNumberTransform, isMarketTime, zIndexUp, zIndexDown, zIndexTop, zIndexBottom, getAuthorization }
